import React, { useEffect, useRef, useState } from 'react'
import MapCenterModal from '../components/modals/MapCenterModal'
import BarraPrincipal from './BarraPrincipal'
import BarraTrafico from './BarraTrafico'
import '../Pages/Css/traficoResponsive.css'
import { Toaster } from "react-hot-toast";

const MapCenter = () => {
    const [contracts, setContracts] = useState([]);
    const mapCenterModalRef = useRef(null);

    useEffect(() => {
        document.body.classList.add('map-center-responsive-page');
        return () => document.body.classList.remove('map-center-responsive-page');
    }, []);

    const toggleNavigationMenu = () => {
        document.querySelector('[class*="sidenav-toggle"]')?.click();
    };

    const loadContracts = async (newValue) => {
        console.log("Cargando contratos...");
        console.log("Nuevo valor:", newValue);
        setContracts(newValue);
    }

    const voidFuncion = () => {
        // Esta funcion no hace nada, pero se puede usar para actualizar el estado o realizar otras acciones si es necesario.
    }

    const handleLiveNow = (msg) => {
        mapCenterModalRef.current?.handleLiveNow?.(msg);
    };

    const handleLiveEnded = (msg) => {
        mapCenterModalRef.current?.handleLiveEnded?.(msg);
    };

    return (
        <div className="layout-wrapper layout-content-navbar trafico-page map-center-page">
            <div className="layout-container">
                <div className="layout-page">
                    <BarraTrafico
                        count={contracts?.length}
                        filteredSolicitudes={contracts}
                        onUpdateSolicitudes={voidFuncion}
                        ListarContratos={voidFuncion}
                        differTime={voidFuncion}
                        onLiveNow={handleLiveNow}
                        onLiveEnded={handleLiveEnded}
                        onToggleNavigation={toggleNavigationMenu}
                    />
                    <Toaster position="bottom-right" />
                    <MapCenterModal ref={mapCenterModalRef} />
                </div>
            </div>
        </div>
    )
}

export default MapCenter
